import { render, staticRenderFns } from "./voteuser.vue?vue&type=template&id=10474160&scoped=true"
import script from "./voteuser.vue?vue&type=script&lang=ts"
export * from "./voteuser.vue?vue&type=script&lang=ts"
import style0 from "./voteuser.vue?vue&type=style&index=0&id=10474160&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10474160",
  null
  
)

export default component.exports